<template>
  <v-btn id="link" :to="to" :fab="fab" x-small text color="light-blue">
    {{ text }}
    <v-icon v-if="icon" x-small>mdi-{{ icon }}</v-icon>
  </v-btn>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";

export default Vue.extend({
  name: "DrillLink",

  data() {
    return {};
  },
  props: {
    to: VueTypes.string.def("/"),
    icon: VueTypes.string.def(""),
    text: VueTypes.string.def(""),
    fab: VueTypes.bool.def(false),
  },
});
</script>
<style scoped>
#link {
  opacity: 0.4;
}
#link:hover {
  opacity: 1;
}
</style>
